import React, { PureComponent } from 'react';
import {
    LineChart,
    AreaChart,
    Area,
    CartesianGrid,
    Legend,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine,
    Line
} from "recharts";



const TatAverages = (props) => {
    const colors = [
        "#525252", "#505d59", "#4c675e", "#437162", "#337b67", "#525252", "#d03682", "#b64779", "#9c5070", "#755561"
        //"#525252", "#7d3e75", "#614e6f", "#3f5e58", "#982f7b", "#455e6a", "#30675c", "#b41f81", "#296d64", "#256f60", "#d01086", "#ec008c"
        //"#00876c",
        //"#3b864b",
        //"#628227",
        //"#887900",
        //"#af6900",
        //"#d14f26",
        //"#e92954",
        //"#ec008c"
        //"
        //"#00876c",
        //"#ec008c",
        //"#cfdfd9",
        //"#f1f1f1",
        //"#f5d3df",
        //"#f7b6ce",
        //"#f797bd",
        //"#f576ac",
        //"#f14f9c",
        //"#ec008c"
    ];
    return (
        <div className="chart givemethefinger" onClick={props.onClick}>
            <div className="chart-internal">
                <div className="title">Average SLA Performance (%) - Last 12 Weeks</div>
                <div style={{ "width": "100%", "height": "14.6rem" }}>  {/*, backgroundColor: "lightgray" */}
                    <ResponsiveContainer>
                        <LineChart
                            data={props.chartData?.data}
                            margin={{
                                top: 5, right: 10, left: 0, bottom: 0,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" strokeWidth={2} stroke="white" />
                            <XAxis dataKey="weekStarting" tick={{ fontWeight: "bold", fontSize: "0.7rem" }} />
                            <YAxis tick={{ fontWeight: "bold", fontSize: "0.7rem" }} width={30} domain={[-100, 100]}/>
                            <Tooltip />
                            <ReferenceLine y={0} label="SLA" stroke="#FF0000" strokeWidth={2} strokeDasharray="3 3"/>
                            {props.chartData?.metaData.map((oType, idx) => (                                
                                <Line type="monotone" dataKey={oType.dataKey} connectNulls stroke={colors[idx]} name={oType.label} strokeWidth={2} activeDot={{ r: 8 }} />
                            ))}
                            {/*<Line type="monotone" dataKey="completed" stroke="#ec008c" name="Completed" strokeWidth={4} activeDot={{ r: 8 }} />*/}
                            {/*<Line type="monotone" dataKey="received" stroke="#01837b" name="Recieved" strokeWidth={4} activeDot={{ r: 8 }} />*/}
                            {/*<Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8" />*/}
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}

export default TatAverages;